/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField, Stack } from "@mui/material";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";
import LabelledField from "components/labelled-field";
import { useTranslation } from "react-i18next";
import { isStringEmpty } from "utils/empty-exists";
import { Logger } from "cms/utils/log/logger";
import { ImageInPageEditorV2 } from "cms/images/image-inpage-editor-v2/index";
import { SingleLinkSelector } from "./single-link-selector";
import { ImageDialogButton } from "cms/images/image-selector/exported/add-image-button/image-dialog-button";

const IconCTAComponentEditor = () => {
    const { t } = useTranslation();

    const { component, update, updateFactory } = useUpdateComponent();
    const title = component?.title;
    const description = component?.description;
    const _image = component?.image;
    const _link = component?.link;
    const _settings = component?.settings;

    // const [image,setImage] = useState(_image);
    // const [settings,setSettings] = useState(_settings);
    const image_settings = _settings?.image_settings;
    
    const onChangeTitle = (event) => {
        const title = event.target.value;
        update("title", title);
    };
    const onChangeDescription = updateFactory("description");
    const onChangeLink = updateFactory("link");
    
    const onChangeImageWithSettings = (image, settings) => {
        const guid = image?.guid;
        if (isStringEmpty(guid)) {
            Logger.warn("[onChangeImageWithSettings] image guid missing", { image, guid });
        } else {
            // setImage(guid);
            // setSettings(settings);
            update("settings.image_settings", settings);
            update("image", guid);
        }
    };
    const onRemoveImage = () => {
        // setImage("");
        // setSettings({});
        update("settings.image_settings", {});
        update("image", "");
    };

    return (
        <div className="simplicity-editor-frame">
            {/*  Image  */}
            <LabelledField label={`${t("commons.image")} :`}>
                <div className="simplicity-image-list-item">
                    <Stack direction="row" justifyContent="flex-start">
                        <div className="simplicity-image-list-item-data" style={{ width: "100%" }}>
                            <Stack direction="column" justifyContent="flex-start" style={{ width: "100%" }}>
                                <div>
                                    <ImageInPageEditorV2
                                        image_guid={_image}
                                        settings={image_settings}
                                        onChangeImageWithSettings={onChangeImageWithSettings}
                                        onRemoveImage={onRemoveImage}
                                        AddButtonComponent={ImageDialogButton}
                                    />
                                </div>
                            </Stack>
                        </div>
                    </Stack>
                </div>
            </LabelledField>
            
            {/*  Title */}
            <LabelledField label={`${t("commons.displayTitle")} :`}>
                <TextField
                    id="section_list_title"
                    fullWidth={true}
                    value={title}
                    placeholder={t("commons.addAHeading")}
                    onChange={onChangeTitle}
                />
            </LabelledField>
            
            {/*  Description  */}
            <LabelledField label={t("commons.description")}>
                <SimplicityComposerEnsureTipTap
                    richtext={description}
                    onChange={onChangeDescription}
                />
            </LabelledField>
            
            {/*  Single Link Selector  */}
            <LabelledField label={t("commons.link")} style={{ marginTop: 12 }}>
                <SingleLinkSelector
                    linkGuid={_link}
                    onChange={onChangeLink}
                />
            </LabelledField>
        </div>
    );
};

IconCTAComponentEditor.displayName = "IconCTAComponentEditor";
export { IconCTAComponentEditor };
